import { render, staticRenderFns } from "./OrderRequestDialog.vue?vue&type=template&id=740b960e&"
import script from "./OrderRequestDialog.vue?vue&type=script&lang=js&"
export * from "./OrderRequestDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderRequestDialog.vue?vue&type=style&index=0&id=740b960e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports